// Token storage helpers for web (using localStorage)
const ACCESS_TOKEN_KEY = 'tellmiz_access_token';
const REFRESH_TOKEN_KEY = 'tellmiz_refresh_token';

const getTokens = async () => {
  try {
    const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (accessToken && refreshToken) {
      return [accessToken, refreshToken];
    }
    return [];
  } catch (error) {
    console.error('Error getting tokens:', error);
    await deleteTokens();
    return [];
  }
};

const setTokens = async (access, refresh) => {
  try {
    localStorage.setItem(ACCESS_TOKEN_KEY, access);
    localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
  } catch (error) {
    console.error('Error setting tokens:', error);
    await deleteTokens();
    return [];
  }
};

const deleteTokens = async () => {
  try {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch (error) {
    console.log('error in deleting tokens', error);
    return [];
  }
};

export { getTokens, setTokens, deleteTokens };

















